export enum SeamTransitions {
    READY_FOR_REVIEW = 'ready_for_review',
    PATTERNS_APPROVED = 'patterns_approved',
    PATTERNS_REJECT = 'reject_retune',
    QA_APPROVED = 'qa_approved',
    QA_REJECTED = 'qa_rejected',
    CLOSE_BY_USER = 'close_by_user',
    UNPUBLISH = 'unpublish',
    PROD_QA_APPROVED = 'prod_qa_approved',
}
